// 必要なコンポーネントをインポート
// UMDisplay: メイン表示部を管理するコンポーネント
import UMDisplay from "../molecules/UMDisplay"; 
// UMSubMenu: サブメニューを管理するコンポーネント
import UMSubMenu from "../molecules/UMSubMenu"; 
// Material-UI（@mui/material）から必要なUIコンポーネントをインポート
import { Container, Box, Grid, AppBar, Typography} from '@mui/material';

/** 
 * UMMainコンポーネント
 * このコンポーネントは「user資料ページ」のメイン表示部を構築する
 * 画面のレイアウトを管理し、UMDisplayとUMSubMenuコンポーネントを表示
 */
const UMMain = () => {

    // コンポーネントの描画部分
    return (
        // レスポンシブなコンテナ（最大幅はlgに制限）
        <Container maxWidth='lg'>
            {/* 余白を設定したボックスを作成 */}
            <Box sx={{padding: 1}}>
                {/* メイン表示部のコンポーネントを表示 */}
                <UMDisplay />
                {/* サブメニューのコンポーネントを表示 */}
                <UMSubMenu />
            </Box>
        </Container>
    );
}

// UMMainコンポーネントをデフォルトエクスポート
export default UMMain;
